import React from "react";
import "./Other.css";

import { useNavigate } from "react-router-dom";

const categories = [
  {
    id: 1,
    name: "Kitchen Appliances",
    count: 1,
    img: "/images/kitchen.jpg",
    link: "-Ow0BvVwsJVeP6ZEzsZZK",
    linkType: "child"
  },
  {
    id: 2,
    name: "Television",
    count: 2,
    img: "/images/television.webp",
    link: "lTISOCozlYH5nzycizPqw",
    linkType: "child"
  },
  {
    id: 3,
    name: "Refrigerators",
    count: 1,
    img: "/images/refrigerator.jpg",
    link: "294L89cNWEGwgzj7TCapg",
    linkType: "child"
  },
  {
    id: 4,
    name: "Bed Sheets",
    count: 2,
    img: "/images/bed.webp",
    link: "DSSPsqMgQ1jLYpxfMfeRL",
    linkType: "child"
  },
  {
    id: 5,
    name: "Pillow",
    count: 0,
    img: "/images/pillow.webp",
    link: "DSSPsqMgQ1jLYpxfMfeRL",
    linkType: "child"
  },
  {
    id: 6,
    name: "Gadget Accessories",
    count: 11,
    img: "/images/gadget.webp",
    link: "CvR6QcKR8VAxmVFT-zgpI",
    linkType: "child"

  },
];

export default function Others() {
  const navigate = useNavigate();

  const handleNavigate = (lk) => {
     navigate("/products", { state: { myLink: lk } });
  }

  return (
    <section className="others">
      <div className="others-head">
        <h2>Autres</h2>
        <div className="rule" />
      </div>

      <div className="others-grid">
        {categories.map((c) => (
          <article key={c.id} className="other-card" onClick={() => handleNavigate(c.link)}>
            <div className="thumb" >
              <img src={c.img} alt={c.name} loading="lazy" />
            </div>
            <div className="meta">
              <h3>{c.name}</h3>
              <p>
                items Available
              </p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
